<ng-container *ngIf="shouldShow">
    <!-- Trigger pill: avatar + name (md+) + chevron slot (sm+) -->
    <button
        type="button"
        #trigger="matMenuTrigger"
        class="establishment-switcher-trigger inline-flex items-center gap-2.5 h-10 pl-1 pr-2.5 rounded-full bg-gray-50 hover:bg-gray-100 border border-transparent transition-all duration-200 dark:bg-gray-800 dark:hover:bg-gray-700"
        [class.menu-open]="trigger.menuOpen"
        [matMenuTriggerFor]="switcherMenu"
        [matTooltip]="currentEstablishment?.name || ('features.establishment-switcher.current' | transloco)"
        aria-haspopup="menu"
        [attr.aria-expanded]="trigger.menuOpen"
        [attr.aria-label]="'features.establishment-switcher.aria-label' | transloco: { name: currentEstablishment?.name || '' }">
        <ng-container *ngIf="shouldShowLogo(currentEstablishment); else triggerInitialTpl">
            <img
                class="avatar h-7 w-7 rounded-full object-cover shrink-0 ring-1 ring-black/5 shadow-sm"
                [src]="logoUrl(currentEstablishment)"
                (error)="onLogoError(currentEstablishment)"
                alt="" />
        </ng-container>
        <ng-template #triggerInitialTpl>
            <span
                class="avatar flex items-center justify-center h-7 w-7 rounded-full shrink-0 ring-1 ring-black/5 shadow-sm text-white font-bold text-xs tracking-wide"
                [ngClass]="colorFor(currentEstablishment)">
                {{ twoInitialsFor(currentEstablishment) }}
            </span>
        </ng-template>
        <span class="hidden md:inline-block text-sm font-semibold text-gray-900 dark:text-gray-100 max-w-[10rem] truncate leading-none">
            {{ currentEstablishment?.name || ('features.establishment-switcher.current' | transloco) }}
        </span>
        <span class="chevron-slot hidden sm:flex h-5 w-5 items-center justify-center rounded-md bg-white/60 dark:bg-gray-800/40">
            <mat-icon class="icon-size-4 text-gray-400">unfold_more</mat-icon>
        </span>
    </button>

    <!-- Menu -->
    <mat-menu
        #switcherMenu="matMenu"
        [xPosition]="'before'"
        class="establishment-switcher-menu"
        panelClass="establishment-switcher-menu">
        <!-- Establishment rows -->
        <button
            mat-menu-item
            *ngFor="let est of establishments"
            (click)="switchTo(est)"
            [class.is-current]="isCurrent(est)"
            [attr.aria-current]="isCurrent(est) ? 'true' : null">
            <span class="flex items-center gap-3 w-full min-h-[48px] py-1">
                <ng-container *ngIf="shouldShowLogo(est); else estInitialTpl">
                    <img
                        class="h-8 w-8 rounded-full object-cover shrink-0 ring-1 ring-black/5"
                        [src]="logoUrl(est)"
                        (error)="onLogoError(est)"
                        alt="" />
                </ng-container>
                <ng-template #estInitialTpl>
                    <span
                        class="flex items-center justify-center h-8 w-8 rounded-full shrink-0 ring-1 ring-black/5 text-white font-bold text-xs tracking-wide"
                        [ngClass]="colorFor(est)">
                        {{ twoInitialsFor(est) }}
                    </span>
                </ng-template>
                <span
                    class="flex-1 min-w-0 text-sm text-gray-900 dark:text-gray-100 truncate leading-none"
                    [class.font-semibold]="isCurrent(est)"
                    [class.font-medium]="!isCurrent(est)">
                    {{ est.name }}
                </span>
                <mat-icon
                    *ngIf="isCurrent(est)"
                    class="icon-size-5 text-shevafood-accent-500 shrink-0"
                    [matTooltip]="'common.labels.current' | transloco"
                    [attr.aria-label]="'common.labels.current' | transloco">
                    check
                </mat-icon>
            </span>
        </button>

        <!-- Add establishment action (if plan + flag allow) -->
        <ng-container *ngIf="multiEstablishmentEnabled">
            <mat-divider class="my-1"></mat-divider>
            <button
                mat-menu-item
                class="add-establishment-row"
                (click)="onAddEstablishmentClick()"
                [disabled]="(!canAdd && isPro) || !canAddMore"
                [matTooltip]="!canAddMore ? ('features.establishment-switcher.limit-reached-tooltip' | transloco) : ''"
                [matTooltipDisabled]="canAddMore">
                <span
                    class="flex items-center gap-3 w-full min-h-[48px] py-1 font-medium text-sm text-shevafood-accent-600 dark:text-shevafood-accent-400"
                    [class.opacity-50]="!canAddMore">
                    <span class="flex items-center justify-center h-8 w-8 rounded-full bg-shevafood-accent-50 dark:bg-shevafood-accent-900/20 shrink-0">
                        <mat-icon class="icon-size-5 text-shevafood-accent-500">add_business</mat-icon>
                    </span>
                    <span>{{ 'features.establishment-switcher.add' | transloco }}</span>
                    <span *ngIf="!isPro" class="ml-auto inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-amber-100 text-amber-800">
                        PRO
                    </span>
                </span>
            </button>
        </ng-container>
    </mat-menu>
</ng-container>
